import { useEffect } from "react";
import {
  APPROVAL_FIELD_NAVIGATE_EVENT,
  parseCarouselCardIndex,
} from "../utils/fieldDomUtils";

const useApprovalFieldNavigateTab = ({
  formPath = "",
  onSelectIndex = () => {},
}) => {
  useEffect(() => {
    if (!formPath) {
      return undefined;
    }

    const handleNavigate = (event) => {
      const path = event?.detail?.path;

      if (!path?.startsWith(formPath)) {
        return;
      }

      const cardIndex = parseCarouselCardIndex(path);

      if (Number.isInteger(cardIndex) && cardIndex >= 0) {
        onSelectIndex(cardIndex);
      }
    };

    window.addEventListener(APPROVAL_FIELD_NAVIGATE_EVENT, handleNavigate);

    return () => {
      window.removeEventListener(APPROVAL_FIELD_NAVIGATE_EVENT, handleNavigate);
    };
  }, [formPath, onSelectIndex]);
};

export default useApprovalFieldNavigateTab;
